const actions = {
    PAYROLL_IMPORT_REQUEST: 'PAYROLL_IMPORT_REQUEST',
    PAYROLL_IMPORT_SUCCESS: 'PAYROLL_IMPORT_SUCCESS',
    PAYROLL_IMPORT_ERROR: 'PAYROLL_IMPORT_ERROR',

    importPayroll: (request, payrollVendor) => ({
        type: actions.PAYROLL_IMPORT_REQUEST,
        request,
        payrollVendor, // talenox OR payroll_panda
    }),
};
export default actions;
